import Home from '@/views/Home'
import Login from '@/views/Login'
import ErrorPage from '@/views/Error'
import CustomObjectHandle from '@/views/customObject/CustomObjectHandle'
import QusetSur from '@/views/questionSurvey'
// import QusetSurList from '@/views/questionSurvey/qsList.vue'
// import QusetSurExport from '@/views/questionSurvey/qsExport.vue'
import scmdDetail from '@/views/layoutDetail/detail.vue'
import Settings from '@/views/settings'
import MenuSettings from '@/views/settings/menus/'
import Register from '@/views/Register'
import Register2 from '@/views/Register2'
import Forget from '@/views/Forget'
import DefaultOnlineService from '@/views/DefaultOnlineService'
import DefaultCallCenter from '@/views/DefaultCallCenter'
import DefaultLostConnection from '@/views/DefaultLostConnection'
import External from '../views/External'
import Question from '@/components/common/questionnaire/demo.vue'
import PersonnalMess from '@/components/PersonnalMess.vue'
import DownloadCenter from '@/views/downloadCenter/index.vue'
const system = [{
        path: '/',
        name: 'home',
        meta: {
            title: '首页',
            NonMenu: true
        },
        component: Home
    },
    {
        path: '/login',
        name: 'login',
        meta: {
            title: '请登录',
            layout: 'layoutBlank',
            NonMenu: true
        },
        component: Login
    },
    {
        path: '/personnalMess',
        name: 'personnalMess',
        meta: {
            title: '个人信息',
            NonMenu: true,
            permissionTag: ''
        },
        component: PersonnalMess
    },
    {
        path: '/error',
        name: 'error',
        meta: {
            title: '页面加载错误',
            layout: 'layoutBlank',
            NonMenu: true
        },
        component: ErrorPage
    },
    {
        path: '/register',
        name: 'register',
        meta: {
            title: '请注册',
            layout: 'layoutBlank',
            NonMenu: true
        },
        component: Register
    },
    {
        path: '/register2',
        name: 'register2',
        meta: {
            title: '请注册',
            layout: 'layoutBlank',
            NonMenu: true
        },
        component: Register2
    },
    {
        path: '/forget',
        name: 'forget',
        meta: {
            title: '忘记密码',
            layout: 'layoutBlank',
            NonMenu: true
        },
        component: Forget
    }
]
const pages = [{
        path: '/scmd-detail',
        name: 'scmd-detail',
        component: scmdDetail,
        meta: {
            title: '详情页',
            NonMenu: true
        }
    },
    {
        id: 'settings',
        path: '/settings',
        component: Settings,
        index: 1,
        meta: {
            title: '基础设置',
            icon: 'caidan-jichushezhi',
            permissionTag: ''
        },
        children: [{
                id: 'homeManage',
                path: '/settings/homeManage',
                name: '/settings/homeManage',
                component: ()=>import("@/views/settings/FirstPageManage.vue"),
                meta: {
                    title: '自定义首页',
                    permissionTag: 'homeConfig'
                }
            },
            {
                id: 'menuManage',
                path: '/settings/menuManage',
                name: '/settings/menuManage',
                component: ()=>import("@/views/settings/menus/"),
                meta: {
                    title: '自定义菜单'
                }
            }
        ]
    },
    {
        path: '/onlineService',
        name: 'DefaultOnlineService',
        meta: {
            title: '在线客服',
            NonMenu: true
        },
        component: DefaultOnlineService
    },
    {
        path: '/callCenter',
        name: 'DefaultCallCenter',
        meta: {
            title: '外拨中心',
            NonMenu: true
        },
        component: DefaultCallCenter
    },
    {
        path: '/lostConnection',
        name: 'DefaultLostConnection',
        meta: {
            title: '失联修复',
            NonMenu: true
        },
        component: DefaultLostConnection
    },
    {
        path: '/custom-object/handle/',
        name: 'CustomObjectHandle',
        meta: {
            type: 'object'
        },
        component: CustomObjectHandle
    },
    {
        id: 'qusetSur',
        path: '/qusetSur',
        component: QusetSur,
        index: 4,
        meta: {
            title: '问卷调查',
            icon: 'caidan-wenjuantiaocha',
            permissionTag: 'qusetSur'
        },
        children: [{
                id: 'qusetSurList',
                path: '/qusetSur/qusetSurList',
                component: ()=>import("@/views/questionSurvey/qsList.vue"),
                meta: {
                    title: '问卷列表',
                    permissionTag: 'qusetSurList'
                }
            },
            {
                id: 'qusetSurExport',
                path: '/qusetSur/qusetSurExport',
                component: ()=>import("@/views/questionSurvey/qsExport.vue"),
                meta: {
                    title: '导出记录',
                    permissionTag: 'qusetSurExport'
                }
            }
        ]
    },
    {
        path: '/external',
        meta: {
            type: 'external'
        },
        component: External
    },
    {
        path: '/question',
        meta: {
            type: 'Question'
        },
        component: Question
    },
    {
        path: '/downloadCenter',
        name: 'downloadCenter',
        meta: {
            title: '下载中心',
            // permissionTag: 'downloadCenter'
        },
        component: DownloadCenter
    },
]
export { system, pages }